// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import Naluri from '~/common/api/naluri';
import {
  COMMON_UNSET_UNREAD_MESSAGE,
  COMMON_UNSET_UNREAD_MESSAGE_BEGIN,
  COMMON_UNSET_UNREAD_MESSAGE_SUCCESS,
  COMMON_UNSET_UNREAD_MESSAGE_FAILURE,
  COMMON_UNSET_UNREAD_MESSAGE_DISMISS_ERROR,
} from './constants';

export function unsetUnreadMessage(id) {
  return (dispatch, getState) => {
    dispatch({
      type: COMMON_UNSET_UNREAD_MESSAGE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.put(`/api/expert/channels/reset_unread/${id}`);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_UNSET_UNREAD_MESSAGE_SUCCESS,
            data: res,
          });
          dispatch(unreadMessage(id));
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_UNSET_UNREAD_MESSAGE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetChannelError() {
  return {
    type: COMMON_UNSET_UNREAD_MESSAGE_DISMISS_ERROR,
  };
}

const unreadMessage = id => ({
  type: COMMON_UNSET_UNREAD_MESSAGE,
  data: id,
});

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_UNSET_UNREAD_MESSAGE:
      const users = state.filteredUserList.map(user => {
        if (user.cid === action.data) {
          return Object.assign(user, { unreads_count: 0 });
        } else {
          return user;
        }
      });

      const newUsers = state.newUsers.map(user => {
        if (user.cid === action.data) {
          return Object.assign(user, { unreads_count: 0 });
        } else {
          return user;
        }
      });

      const recentlyReassignedUsers = state.recentlyReassignedUsers.map(user => {
        if (user.cid === action.data) {
          return Object.assign(user, { unreads_count: 0 });
        } else {
          return user;
        }
      });

      const groups = state.groups.map(group => {
        if (group.cid === action.data) {
          return Object.assign(group, { unreads_count: 0 });
        } else {
          return group;
        }
      });

      return {
        ...state,
        filteredUserList: users,
        newUsers: newUsers,
        recentlyReassignedUsers: recentlyReassignedUsers,
        groups: groups,
        users: users,
        recentlyReassignedUsersChannels: recentlyReassignedUsers,
        newUsersChannels: newUsers,
      };

    case COMMON_UNSET_UNREAD_MESSAGE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getUnsetUnreadMessagePending: true,
        getUnsetUnreadMessagePendingError: null,
      };

    case COMMON_UNSET_UNREAD_MESSAGE_SUCCESS:
      // The request is success
      return {
        ...state,
        getUnsetUnreadMessagePending: false,
        getUnsetUnreadMessagePendingError: null,
      };

    case COMMON_UNSET_UNREAD_MESSAGE_FAILURE:
      // The request is failed
      return {
        ...state,
        getUnsetUnreadMessagePending: false,
        getUnsetUnreadMessagePendingError: action.data.error,
      };

    case COMMON_UNSET_UNREAD_MESSAGE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getUnsetUnreadMessagePendingError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/unsetUnreadMessage.js